<template>
  <div class="container-fluid bmo-form">
    <div class="card-header py-3">
      <h6 class="m-0 font-weight-bold text-primary">Create Media2</h6>
    </div>
    <div class="card-body text-align-left">
      <Form type="Update" :item="page" @submit="handleFormSubmit" @image-show="imageShow" />
    </div>
    <b-modal ref="modal" :title="modal.title" size="xl" ok-only>
      <p :style="modal.styles">{{ modal.content }}</p>
    </b-modal>
    <!-- close card body -->
  </div>
  <!-- close container-fluid -->
</template>

<script>
import { BModal } from "bootstrap-vue";
import Form from "@/components/Forms/MediaPageForm2.vue";
import router from "@/router";

export default {
  name: "CreateMedia",
  components: {
    Form,
    BModal,
  },
  data: () => ({
    modal: {
      title: "",
      content: "",
      styles: "{white-space: pre;}",
    },
  }),
  computed: {
    page() {
      return this.$route.params.id;
    },
  },
  methods: {
    imageShow(path, img) {

      this.modal = Object.assign(this.modal, {
        title: path,
        styles: "{white-space: pre; background-image: url('" + img + "'); background-size: contain; background-repeat: no-repeat; width: 100%; height: 0; padding-top: 66.64%;}",
      });
      this.$refs.modal.show();
    },
    handleFormSubmit(errors) {
      if (errors.length === 0) {
        router.back();
      } else {
        this.modal = Object.assign(
          {},
          {
            title: "Error",
          }
        );

        let content = "";

        errors.forEach((error) => {
          content += "* " + error + "\n";
        });

        this.modal = Object.assign(this.modal, {
          content: content,
        });

        this.$refs.modal.show();
      }
    },
  },
};
</script>
